// TODO: Review AI Code for feature: System Landscape & Interactions Visualization - Entire file is AI-generated
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../client';
import { systemKeys } from '../query-keys';
import { useAuthStore } from '@/stores/auth-store';
import type { SystemLandscapeResponse } from '@bliks-io/contracts';

/** Fetches the full system landscape (nodes, edges, summary KPIs) for the landscape page. */
export function useSystemLandscape() {
  const { token } = useAuthStore();

  return useQuery({
    queryKey: systemKeys.landscape(),
    queryFn: async ({ signal }): Promise<SystemLandscapeResponse['data']> => {
      const { data } = await apiClient.get<SystemLandscapeResponse>('/api/v2/system/landscape', {
        signal
      });
      return data.data;
    },
    enabled: !!token,
    staleTime: 5 * 60 * 1000 // 5 min cache
  });
}
